import { render, staticRenderFns } from "./FireComplaintFiledModal.vue?vue&type=template&id=36b2044a&scoped=true"
import script from "./FireComplaintFiledModal.vue?vue&type=script&lang=ts"
export * from "./FireComplaintFiledModal.vue?vue&type=script&lang=ts"
import style0 from "./FireComplaintFiledModal.vue?vue&type=style&index=0&id=36b2044a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2044a",
  null
  
)

export default component.exports